import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import { __extends } from "tslib";
import PropTypes from 'prop-types';
import classnames from 'classnames';
import dayjs from '../dayjs';
import { isAllowedDate, getTodayTime } from '../util';
injectStyle("components/DatePicker/rc-calendar/style/common/CalendarMixin.css", "[data-dui-0-122-5~=\"dui-calendar\"]{position:relative;width:320px;background-color:#fff;border-radius:4px;-webkit-box-shadow:0 0 0 1px rgba(0,0,0,.04),0 4px 6px 2px rgba(0,0,0,.04),0 6px 32px 2px rgba(0,0,0,.16);box-shadow:0 0 0 1px rgba(0,0,0,.04),0 4px 6px 2px rgba(0,0,0,.04),0 6px 32px 2px rgba(0,0,0,.16);font-size:12px;line-height:1.5;list-style:none;outline:none;text-align:left}");
export function getNowByCurrentStateValue(value) {
    return value ? getTodayTime(value) : dayjs();
}
export var calendarMixinPropTypes = {
    defaultValue: PropTypes.object,
    value: PropTypes.object,
    onKeyDown: PropTypes.func,
};
export var calendarMixinDefaultProps = {
    onKeyDown: Function.prototype,
};
export var calendarMixinWrapper = function (ComposeComponent) { var _a; return _a = (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.onSelect = function (value, cause) {
                if (value) {
                    _this.setValue(value);
                }
                _this.setSelectedValue(value, cause);
            };
            _this.renderRoot = function (newProps) {
                var _a;
                var _b = _this.props, className = _b.className, prefixCls = _b.prefixCls, style = _b.style, visible = _b.visible;
                return (h("div", { ref: _this.saveRoot, role: "menu", style: style, tabIndex: 0, className: classnames(prefixCls, className, newProps.className, (_a = {},
                        _a[prefixCls + "-hidden"] = !visible,
                        _a)), onBlur: _this.onBlur, onKeyDown: _this.onKeyDown }, newProps.children));
            };
            _this.setSelectedValue = function (selectedValue, cause) {
                var _a, _b;
                if (!(_this.props.selectedValue)) {
                    _this.setState({
                        selectedValue: selectedValue,
                    });
                }
                (_b = (_a = _this.props).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, selectedValue, cause);
            };
            _this.setValue = function (value) {
                var originalValue = _this.state.value;
                if (!(_this.props.value)) {
                    _this.setState({
                        value: value,
                    });
                }
                if ((!originalValue && !value) || (originalValue === null || originalValue === void 0 ? void 0 : originalValue.isSame(value))) {
                    return;
                }
                _this.props.onChange(value);
            };
            _this.isAllowedDate = function (value) {
                var _a = _this.props, disabledDate = _a.disabledDate, disabledTime = _a.disabledTime;
                return isAllowedDate(value, disabledDate, disabledTime);
            };
            return _this;
        }
        class_1.getDerivedStateFromProps = function (props, state) {
            if (ComposeComponent.getDerivedStateFromProps) {
                return ComposeComponent.getDerivedStateFromProps(props, state);
            }
            var value = props.value, selectedValue = props.selectedValue;
            var newState = {};
            if (props.value) {
                newState.value = value || props.defaultValue || getNowByCurrentStateValue(state.value);
            }
            if (props.selectedValue) {
                newState.selectedValue = selectedValue;
            }
            return newState;
        };
        return class_1;
    }(ComposeComponent)),
    _a.displayName = 'CalendarMixinWrapper',
    _a.defaultProps = ComposeComponent.defaultProps,
    _a; };
